import { FIRST_TIME_BUYER_QUESTION_ID } from 'site-modules/shared/components/incentives/incentives-wizard/questions/questions';
import { mapBase } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/base-mapper';

const ELIGIBILITY_FIELD_QUESTIONS_MAP = {
  assistanceParticipant: [FIRST_TIME_BUYER_QUESTION_ID],
};

export const mapFirstTimeBuyer = field => ELIGIBILITY_FIELD_QUESTIONS_MAP[field] || mapBase(field);
